export const sortedSizeOptions = {
  0: 1940,
  '0-1C': 1480,
  '0-3M': 1080,
  '0-6M': 1090,
  '0.5C': 1210,
  '0C': 1200,
  '0M': 1000,
  1: 1950,
  '1-2C': 1490,
  '1-2T': 1650,
  '1-2Y': 1880,
  '1.5C': 1230,
  '1.5Y': 1710,
  10: 2160,
  10.5: 2170,
  '10.5C': 1410,
  '10C': 1400,
  11: 2180,
  11.25: 2190,
  11.5: 2200,
  '11.5C': 1430,
  11.75: 2210,
  '11C': 1420,
  12: 2220,
  '12-18M': 1150,
  '12-24M': 1160,
  12.5: 2230,
  '12.5C': 1450,
  12.75: 2240,
  '12C': 1440,
  '12M': 1040,
  13: 2250,
  13.5: 2260,
  '13.5C': 1470,
  '13/14': 4320,
  '13/16': 4330,
  '13C': 1460,
  14: 2270,
  14.5: 2280,
  '14/16': 4340,
  15: 2290,
  15.5: 2300,
  '15/16': 4350,
  16: 2310,
  16.5: 2320,
  17: 2330,
  17.5: 2340,
  18: 2350,
  '18-24M': 1170,
  18.5: 2360,
  '18M': 1050,
  19: 2370,
  19.5: 2380,
  '1C': 1220,
  '1T': 1580,
  '1X': 6910,
  '1X Short': 6750,
  '1X Tall': 6760,
  '1Y': 1700,
  2: 1960,
  '2-3 XL': 6940,
  '2-3C': 1500,
  '2-3T': 1660,
  '2-3Y': 1890,
  2.5: 1970,
  '2.5C': 1250,
  '2.5Y': 1730,
  20: 2390,
  20.5: 2400,
  21: 2410,
  21.5: 2420,
  22: 2430,
  22.5: 2440,
  23: 2450,
  23.5: 2460,
  24: 2470,
  '24-30M': 1180,
  '24-36M': 1190,
  24.5: 2480,
  '24/13': 4360,
  '24/14': 4370,
  '24/15': 4380,
  '24/16': 4390,
  '24/30': 4400,
  '24L': 3010,
  '24M': 1060,
  '24R': 3020,
  '24S': 3030,
  25: 2490,
  25.5: 2500,
  '25/14': 4410,
  '25/15': 4420,
  '25/16': 4430,
  '25/17': 4440,
  '25/18': 4450,
  26: 2510,
  26.5: 2520,
  '26/14': 4460,
  '26/15': 4470,
  '26/16': 4480,
  '26/17': 4490,
  '26/18': 4500,
  '26/19': 4510,
  '26/20': 4520,
  '26L': 3040,
  '26R': 3050,
  '26S': 3060,
  27: 2530,
  27.5: 2540,
  '27/15': 4530,
  '27/16': 4540,
  '27/18': 4550,
  '27/19': 4560,
  '27/20': 4570,
  '27/21': 4580,
  28: 2550,
  28.5: 2560,
  '28/15': 4590,
  '28/16': 4600,
  '28/17': 4610,
  '28/18': 4620,
  '28/19': 4630,
  '28/20': 4640,
  '28/21': 4650,
  '28/22': 4660,
  '28/28': 4670,
  '28/30': 4680,
  '28/32': 4690,
  '28/33': 4700,
  '28/34': 4710,
  '28/36': 4720,
  '28L': 3070,
  '28R': 3080,
  '28S': 3090,
  29: 2570,
  29.5: 2580,
  '29/16': 4730,
  '29/17': 4740,
  '29/18': 4750,
  '29/19': 4760,
  '29/20': 4770,
  '29/21': 4780,
  '29/22': 4790,
  '29/23': 4800,
  '29/28': 4810,
  '29/30': 4820,
  '29/32': 4830,
  '29/33': 4840,
  '29/34': 4850,
  '2C': 1240,
  '2T': 1590,
  '2X': 6920,
  '2X Tall': 6770,
  '2XL': 6460,
  '2XL Short': 6690,
  '2XL Tall': 6700,
  '2XL-TT': 6870,
  '2XS': 6560,
  '2Y': 1720,
  3: 1980,
  '3-4 XL': 6950,
  '3-4.5Y': 1900,
  '3-4C': 1510,
  '3-4T': 1670,
  '3-6M': 1100,
  3.5: 1990,
  '3.5C': 1270,
  '3.5Y': 1750,
  30: 2590,
  30.5: 2600,
  '30/16': 4860,
  '30/17': 4870,
  '30/18': 4880,
  '30/19': 4890,
  '30/20': 4900,
  '30/21': 4910,
  '30/22': 4920,
  '30/23': 4930,
  '30/24': 4940,
  '30/25': 4950,
  '30/27': 4960,
  '30/28': 4970,
  '30/29': 4980,
  '30/30': 4990,
  '30/32': 5000,
  '30/33': 5010,
  '30/34': 5020,
  '30/36': 5030,
  '30A': 3400,
  '30A/B': 3410,
  '30B': 3420,
  '30B/C': 3430,
  '30C': 3440,
  '30C/D': 3450,
  '30D': 3460,
  '30L': 3100,
  '30R': 3110,
  '30S': 3120,
  31: 2610,
  31.5: 2620,
  '31/16': 5040,
  '31/17': 5050,
  '31/18': 5060,
  '31/19': 5070,
  '31/20': 5080,
  '31/21': 5090,
  '31/22': 5100,
  '31/23': 5110,
  '31/24': 5120,
  '31/25': 5130,
  '31/26': 5140,
  '31/28': 5150,
  '31/30': 5160,
  '31/32': 5170,
  '31/33': 5180,
  '31/34': 5190,
  32: 2630,
  32.5: 2640,
  '32/16': 5200,
  '32/19': 5210,
  '32/20': 5220,
  '32/21': 5230,
  '32/22': 5240,
  '32/23': 5250,
  '32/24': 5260,
  '32/25': 5270,
  '32/26': 5280,
  '32/27': 5290,
  '32/28': 5300,
  '32/29': 5310,
  '32/30': 5320,
  '32/32': 5330,
  '32/34': 5340,
  '32/36': 5350,
  '32/38': 5360,
  '32A': 3470,
  '32A/B': 3480,
  '32B': 3490,
  '32B/C': 3500,
  '32C': 3510,
  '32C/D': 3520,
  '32D': 3530,
  '32DD': 3540,
  '32E': 3550,
  '32L': 3130,
  '32R': 3140,
  '32S': 3150,
  33: 2650,
  33.5: 2660,
  '33/16': 5370,
  '33/19': 5380,
  '33/21': 5390,
  '33/22': 5400,
  '33/23': 5410,
  '33/24': 5420,
  '33/25': 5430,
  '33/26': 5440,
  '33/27': 5450,
  '33/28': 5460,
  '33/29': 5470,
  '33/30': 5480,
  '33/32': 5490,
  '33/34': 5500,
  '33/36': 5510,
  34: 2670,
  34.5: 2680,
  '34/16': 5520,
  '34/19': 5530,
  '34/21': 5540,
  '34/22': 5550,
  '34/23': 5560,
  '34/24': 5570,
  '34/25': 5580,
  '34/26': 5590,
  '34/27': 5600,
  '34/28': 5610,
  '34/29': 5620,
  '34/30': 5630,
  '34/31': 5640,
  '34/32': 5650,
  '34/34': 5660,
  '34/35': 5670,
  '34/36': 5680,
  '34/38': 5690,
  '34/40': 5700,
  '34A': 3560,
  '34A/B': 3570,
  '34B': 3580,
  '34B/C': 3590,
  '34C': 3600,
  '34C/D': 3610,
  '34D': 3620,
  '34DD': 3630,
  '34DDD': 3640,
  '34E': 3650,
  '34L': 3160,
  '34R': 3170,
  '34S': 3180,
  35: 2690,
  35.5: 2700,
  '35/22': 5710,
  '35/26': 5720,
  '35/30': 5730,
  '35/32': 5740,
  '35/34': 5750,
  '35/35': 5760,
  '35/36': 5770,
  36: 2710,
  36.5: 2720,
  '36/10': 5780,
  '36/16': 5790,
  '36/19': 5800,
  '36/21': 5810,
  '36/22': 5820,
  '36/28': 5830,
  '36/30': 5840,
  '36/32': 5850,
  '36/34': 5860,
  '36/35': 5870,
  '36/36': 5880,
  '36/38': 5890,
  '36/40': 5900,
  '36A': 3660,
  '36A/B': 3670,
  '36B': 3680,
  '36B/C': 3690,
  '36C': 3700,
  '36C/D': 3710,
  '36D': 3720,
  '36DD': 3730,
  '36DDD': 3740,
  '36E': 3750,
  '36L': 3190,
  '36M': 1070,
  '36R': 3200,
  '36S': 3210,
  37: 2730,
  37.5: 2740,
  38: 2750,
  38.5: 2760,
  '38/12': 5910,
  '38/16': 5920,
  '38/19': 5930,
  '38/21': 5940,
  '38/22': 5950,
  '38/28': 5960,
  '38/30': 5970,
  '38/32': 5980,
  '38/34': 5990,
  '38/36': 6000,
  '38/38': 6010,
  '38A': 3760,
  '38A/B': 3770,
  '38B': 3780,
  '38B/C': 3790,
  '38C': 3800,
  '38C/D': 3810,
  '38D': 3820,
  '38DD': 3830,
  '38DDD': 3840,
  '38E': 3850,
  '38L': 3220,
  '38R': 3230,
  '38S': 3240,
  39: 2770,
  39.5: 2780,
  '3C': 1260,
  '3M': 1010,
  '3T': 1600,
  '3X': 6930,
  '3X Tall': 6780,
  '3XL': 6470,
  '3XL Short': 6710,
  '3XL Tall': 6720,
  '3XL-TT': 6880,
  '3XS': 6570,
  '3Y': 1740,
  4: 2000,
  '4-5 XL': 6960,
  '4-5.5': 2100,
  '4-5.5Y': 1910,
  '4-5C': 1520,
  '4-5T': 1680,
  4.5: 2010,
  '4.5C': 1290,
  '4.5Y': 1770,
  40: 2790,
  40.5: 2800,
  '40/19': 6020,
  '40/21': 6030,
  '40/22': 6040,
  '40/28': 6050,
  '40/30': 6060,
  '40/32': 6070,
  '40/34': 6080,
  '40/36': 6090,
  '40/38': 6100,
  '40/42': 6110,
  '40A': 3860,
  '40A/B': 3870,
  '40B': 3880,
  '40B/C': 3890,
  '40C': 3900,
  '40C/D': 3910,
  '40D': 3920,
  '40DD': 3930,
  '40DDD': 3940,
  '40E': 3950,
  '40L': 3250,
  '40R': 3260,
  '40S': 3270,
  41: 2810,
  41.5: 2820,
  42: 2830,
  '42/19': 6120,
  '42/21': 6130,
  '42/22': 6140,
  '42/28': 6150,
  '42/30': 6160,
  '42/32': 6170,
  '42/34': 6180,
  '42/36': 6190,
  '42/38': 6200,
  '42/44': 6210,
  '42A': 3960,
  '42A/B': 3970,
  '42B': 3980,
  '42B/C': 3990,
  '42C': 4000,
  '42C/D': 4010,
  '42D': 4020,
  '42DD': 4030,
  '42DDD': 4040,
  '42E': 4050,
  '42L': 3280,
  '42R': 3290,
  '42S': 3300,
  43: 2840,
  43.5: 2850,
  44: 2860,
  44.5: 2870,
  '44/19': 6220,
  '44/21': 6230,
  '44/22': 6240,
  '44/28': 6250,
  '44/30': 6260,
  '44/32': 6270,
  '44/33': 6280,
  '44/34': 6290,
  '44/36': 6300,
  '44/38': 6310,
  '44/46': 6320,
  '44A': 4060,
  '44A/B': 4070,
  '44B': 4080,
  '44B/C': 4090,
  '44C': 4100,
  '44C/D': 4110,
  '44D': 4120,
  '44DD': 4130,
  '44DDD': 4140,
  '44E': 4150,
  '44L': 3310,
  '44R': 3320,
  '44S': 3330,
  45: 2880,
  45.5: 2890,
  46: 2900,
  46.5: 2910,
  '46/48': 6370,
  '46L': 3340,
  '46R': 3350,
  '46S': 3360,
  47: 2920,
  47.5: 2930,
  48: 2940,
  '48/2': 6340,
  '48/4': 6350,
  '48/50': 6330,
  '48/6': 6360,
  '48E': 4160,
  '48L': 3390,
  '48R': 3370,
  '48S': 3380,
  49: 2950,
  '4C': 1280,
  '4T': 1610,
  '4XL': 6480,
  '4XL Tall': 6730,
  '4XL-TT': 6890,
  '4XS': 6580,
  '4Y': 1760,
  5: 2020,
  '5-6.5Y': 1920,
  '5-6C': 1530,
  '5-6T': 1690,
  5.5: 2030,
  '5.5C': 1310,
  '5.5Y': 1790,
  50: 2960,
  52: 2970,
  54: 2980,
  56: 2990,
  '5C': 1300,
  '5T': 1620,
  '5XL': 6490,
  '5XL Tall': 6740,
  '5XL-TT': 6900,
  '5Y': 1780,
  6: 2040,
  '6 1/2': 4190,
  '6 1/4': 4180,
  '6 1/8': 4170,
  '6 3/4': 4200,
  '6 3/8': 4210,
  '6 5/8': 4220,
  '6 7/8': 4230,
  '6-12M': 1120,
  '6-18M': 1130,
  '6-7.5': 2110,
  '6-7C': 1540,
  '6-8.5Y': 1930,
  '6-9M': 1110,
  6.5: 2060,
  '6.5C': 1330,
  '6.5Y': 1810,
  60: 3000,
  '6C': 1320,
  '6M': 1020,
  '6T': 1630,
  '6X': 2050,
  '6XL': 6500,
  '6XL Tall': 6790,
  '6Y': 1800,
  7: 2070,
  '7 1/2': 4260,
  '7 1/4': 4250,
  '7 1/8': 4240,
  '7 3/4': 4270,
  '7 3/8': 4280,
  '7 5/8': 4290,
  '7 7/8': 4300,
  '7-8C': 1550,
  7.5: 2080,
  '7.5C': 1350,
  '7.5Y': 1830,
  '7C': 1340,
  '7Y': 1820,
  8: 2090,
  '8 1/8': 4310,
  '8-9.5': 2120,
  '8-9C': 1560,
  8.5: 2130,
  '8.5C': 1370,
  '8.5T': 1640,
  '8.5Y': 1850,
  '8C': 1360,
  '8Y': 1840,
  9: 2140,
  '9-10C': 1570,
  '9-12M': 1140,
  9.5: 2150,
  '9.5C': 1390,
  '9.5Y': 1870,
  '9C': 1380,
  '9M': 1030,
  '9Y': 1860,
  CHILD: 6990,
  CUSTOM: 7010,
  INFANT: 6970,
  L: 6440,
  'L Short': 6650,
  'L TALL': 6660,
  'L-TT': 6840,
  'L/XL': 6550,
  LT: 6830,
  M: 6430,
  'M Short': 6630,
  'M TALL': 6640,
  'M-TT': 6810,
  'M-TTT': 6820,
  'M/L': 6540,
  'ONE SIZE': 7000,
  S: 6420,
  'S Short': 6610,
  'S Tall': 6620,
  'S-TT': 6800,
  'S/M': 6530,
  TODDLER: 6980,
  XL: 6450,
  'XL Short': 6670,
  'XL Tall': 6680,
  'XL-TT': 6860,
  XLT: 6850,
  XS: 6410,
  'XS Short': 6590,
  'XS Tall': 6600,
  'XS/S': 6520,
  'XX/XS': 6510,
  XXS: 6400,
  XXXS: 6390,
  XXXXS: 6380
};
